const m = window.require("discourse/lib/user-search");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;